<script>

import V4WxOpenLaunchWeapp from "@/page/v2/components/v4/v4-wx-open-launch-weapp.vue";

export default {
  name: "renewal-notice-dialog",
  components: {V4WxOpenLaunchWeapp},
  data() {
    return {
      showTag: false,
      title: '',
      jobNum: '',
      content: ''
    }
  },
  methods: {
    /**
     * 打开弹窗
     * @param options
     * @param options.title
     * @param options.content
     * @param options.jobNum
     */
    open(options) {
      this.jobNum = options.jobNum
      this.title = options.title
      this.content = options.content
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    }
  },
}
</script>

<template>
  <van-popup position="bottom" v-model="showTag" @closed="$emit('closed')">
    <div>
      <div class="title fs16 fw600 flex flex-center flex-center-2">{{ title }}</div>
      <div class="content pl15 pr15 pb15 pt15" v-html="content"></div>
      <div class="btns flex pt10 pb10 bt">
        <van-button round class="btn" @click="close">不同意并退出</van-button>
        <van-button type="info" round class="btn" @click="close">同意并继续
          <v4-wx-open-launch-weapp
            :info="{path:'/consulting/furConsultConfirm/furConsultConfirm?jobNum='+jobNum+'&source=1'}"/>
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<style scoped lang="scss">
@import "../../common/public";

.content {
  height: 60vh;
  overflow-y: auto;
}

.title {
  height: 45px;
}

.btns {
  justify-content: space-around;

  .btn {
    width: px2rem(150px);
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/renewal-notice-dialog.vue